// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"0afa814b","242":"eb77838b","362":"c020bd82","524":"69ad2a17","698":"eb79ac6d","770":"384e12fc","970":"606c8d97"}[chunkId] + ".chunk.js";
};